import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import {
  Box, Button, withStyles, Paper, TextField, RadioGroup,
  Radio, FormControlLabel,
} from '@material-ui/core';
import { ArrowForwardIos as ArrowForwardIosIcon } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import FormTitle from '../../../../components/atoms/formTitle/FormTitle';
import FormErrorText from '../../../../components/atoms/formErrorText/FormErrorText';
import SearchSelectBox from '../../../../components/atoms/searchSelectBox/SearchSelectBox';
import Datepicker from '../../../../components/atoms/datepicker/Datepicker';
import MailTemplateSelector from './MailTemplateSelector';
import { actCallMailTemplates } from '../../../../redux/setting/mailMagazineEntry/action';

// #region css
const styles = (theme) => ({
  root: {
    marginBottom: theme.spacing(10),
    paddingBottom: theme.spacing(5),
  },
  textCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  footer: {
    zIndex: '1000',
    width: '100%!important',
    position: 'fixed!important',
    bottom: '0',
    left: '0',
    background: '#fff',
    boxShadow: '0 -8px 10px -9px rgba(0,0,0,.05), 0 3px 14px 2px rgba(0,0,0,.01), 0 5px 5px -3px rgba(0,0,0,.05)',
  },
});
// #endregion

const HOUR_OPTIONS = [
  { id: 0, name: '0時' }, { id: 1, name: '1時' }, { id: 2, name: '2時' }, { id: 3, name: '3時' },
  { id: 4, name: '4時' }, { id: 5, name: '5時' }, { id: 6, name: '6時' },
  { id: 7, name: '7時' }, { id: 8, name: '8時' }, { id: 9, name: '9時' },
  { id: 10, name: '10時' }, { id: 11, name: '11時' }, { id: 12, name: '12時' },
  { id: 13, name: '13時' }, { id: 14, name: '14時' }, { id: 15, name: '15時' },
  { id: 16, name: '16時' }, { id: 17, name: '17時' }, { id: 18, name: '18時' },
  { id: 19, name: '19時' }, { id: 20, name: '20時' }, { id: 21, name: '21時' },
  { id: 22, name: '22時' }, { id: 23, name: '23時' },
];

class BaseInfo extends React.Component {
  constructor(props) {
    super(props);
    let isMain = false;
    if (props.common.user) {
      isMain = props.common.user.main;
    }
    this.state = {
      isMain,
      selectTemplate: '0',
    };
  }

  componentDidMount() {
    this.props.dispatch(actCallMailTemplates({ mstStoreId: this.props.data.mstStore.id }));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data.mstStore !== this.props.data.mstStore) {
      if (this.props.data.mstStore) {
        this.props.dispatch(actCallMailTemplates({ mstStoreId: this.props.data.mstStore.id }));
      }
    }
  }

  scrollToTop = () => window.scrollTo(0, 0);

  handleChange = (e) => {
    this.props.onChange(e, this.props.type);
  }

  handleChangeDate = (value) => {
    const event = {
      target: {
        name: 'sendDate',
        value,
      },
    };
    this.props.onChange(event, this.props.type);
  }

  handleRadioChange = (event) => {
    const { value: selectTemplate } = event.target;
    this.setState({ selectTemplate });
  }

  handleToNext = () => {
    const { type, activeStep } = this.props;
    this.props.onChangeStep(type, activeStep + 1);
  }

  hasError = () => {
    const { errorMessage } = this.props;
    return Object.values(errorMessage).some((v) => v !== '');
  }

  handleSave = () => {
    this.props.onSave(this.props.type);
  }

  render() {
    const {
      classes,
      initSelectValues,
      data,
      templates,
      errorMessage,
      onSelectTemplate,
      fromDetail,
    } = this.props;

    const {
      isMain,
      selectTemplate,
    } = this.state;

    return (
      <div className={classes.root}>
        <Box my={3}>
          <Alert style={{ display: this.hasError() ? '' : 'none' }} severity="error">入力エラーがあります。確認してください。</Alert>
        </Box>

        <Paper elevation={0} variant="outlined">
          <Box p={3}>
            <Box mb={3} display={isMain ? '' : 'none'}>
              <FormTitle title="店舗" isRequired />
              {initSelectValues.stores && (
                <SearchSelectBox
                  name="mstStore"
                  onChange={this.handleChange}
                  value={data.mstStore}
                  options={initSelectValues.stores}
                  error={errorMessage.mstStore !== ''}
                  placeholder="選択してください"
                  disableClearable
                />
              )}
              <FormErrorText>{errorMessage.mstStore}</FormErrorText>
            </Box>

            <Box mb={3}>
              <FormTitle title="タイトル" isRequired />
              <TextField
                name="title"
                id="title"
                variant="outlined"
                onChange={this.handleChange}
                autoComplete="off"
                value={data.title}
                error={errorMessage.title !== ''}
                inputProps={{ maxLength: 50 }}
                fullWidth
              />
              <FormErrorText>{errorMessage.title}</FormErrorText>
            </Box>

            {fromDetail && isMain && (
            <Box mb={3} width="30%">
              <FormTitle title="ステータス" />
              <SearchSelectBox
                options={initSelectValues.status ?? []}
                value={data.status}
                onChange={this.handleChange}
                name="status"
                disableClearable
              />
            </Box>
            )}

            <Box mb={3}>
              <FormTitle title="送信日時" />
              <Box display="flex">
                <Box>
                  <Datepicker
                    value={data.sendDate}
                    handleChange={(dateValue, value) => this.handleChangeDate(value)}
                    error={errorMessage.sendAt !== ''}
                  />
                  <FormErrorText>{errorMessage.sendAt}</FormErrorText>
                </Box>
                <Box pl={1} width="15%">
                  <SearchSelectBox
                    options={HOUR_OPTIONS}
                    value={data.sendHour}
                    onChange={this.handleChange}
                    error={errorMessage.sendAt !== ''}
                    name="sendHour"
                  />
                </Box>
              </Box>
            </Box>

            {!fromDetail && (
              <>
                <Box mb={3}>
                  <FormTitle title="テンプレートの選択" />
                  <RadioGroup
                    row
                    value={selectTemplate}
                    onChange={this.handleRadioChange}
                  >
                    <FormControlLabel value="0" control={<Radio />} label="テンプレートなし" />
                    <FormControlLabel value="1" control={<Radio />} label="テンプレート選択" />
                  </RadioGroup>
                </Box>

                {selectTemplate === '1' && (
                  <Box mb={3}>
                    <MailTemplateSelector
                      datas={templates}
                      onSelectTemplate={onSelectTemplate}
                      selected={data.mstMailTemplate}
                    />
                  </Box>
                )}
              </>
            )}
          </Box>
        </Paper>

        <Box position="fixed" pb={2} className={classes.footer}>
          <Box align="center" textAlign="center" mt={2} display={{ xs: 'block', sm: 'flex' }} justifyContent="center" alignItems="center">
            {!fromDetail ? (
              <Button
                color="primary"
                variant="contained"
                onClick={this.handleToNext}
                endIcon={<ArrowForwardIosIcon />}
              >
                次へ
              </Button>
            ) : (
              <Button
                color="primary"
                variant="contained"
                onClick={this.handleSave}
                endIcon={null}
              >
                保存
              </Button>
            )}
          </Box>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  common: state.common,
});

export default withStyles(styles)(withRouter(connect(mapStateToProps)(BaseInfo)));
